import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { LocationGroupRepository } from "../../repositories/location-group.repository";
import { LocationGroup } from "../../domain/models/location-group";

@Injectable({ providedIn: 'root' })
export class GetLocationsGroupByIdUsecase implements UseCase<string, LocationGroup> {

  constructor(private readonly locationGroupRepository: LocationGroupRepository) {
  }

  execute(param:string): Observable<LocationGroup> {
    return this.locationGroupRepository.GetLocationsGroupById(param);
  }

}
